import {useQuery} from '@apollo/react-hooks';

import type {CoreEntityType} from 'nutshell-core/types';
import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {
    GetAudienceForEntityList as GetAudienceForEntityListQuery,
    GetAudienceForEntityListVariables as GetAudienceForEntityListVariables,
    GetAudienceForEntityList_audience as Audience,
} from 'nutshell-graphql-types';

import GET_AUDIENCE_FOR_ENTITY_LIST from '../queries/get-audience.graphql';

export const useGetAudienceForEntityList = (
    id: string | null | undefined,
    entityType: CoreEntityType
): {
    audience: Audience | null | undefined;
    isLoading: boolean;
    error: string | null | undefined;
    refetch: () => Promise<any>;
} => {
    const {loading, data, error, refetch} = useQuery<
        GetAudienceForEntityListQuery,
        GetAudienceForEntityListVariables
    >(GET_AUDIENCE_FOR_ENTITY_LIST, {
        variables: {
            // @ts-expect-error
            id,
        },
        skip: !id || entityType !== 'contacts',
    });

    const audience = data ? data.audience : null;

    return {
        audience,
        isLoading: loading,
        // @ts-expect-error
        error: safelyGetGraphQLErrorMessage(error),
        refetch,
    };
};
